import React from 'react';
import { Link } from 'react-router-dom';

export default function Raghuram() {
  return (
    <div className="w-full bg-slate-950">
      {/* Hero Section */}
      <section className="relative py-20 md:py-32 bg-gradient-to-b from-slate-900 to-slate-800 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 right-20 w-72 h-72 bg-amber-500 rounded-full mix-blend-multiply filter blur-3xl"></div>
          <div className="absolute bottom-10 left-20 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Raghuram Shetty: <span className="text-amber-400">The Visionary</span>
            </h1>
            <p className="text-xl text-slate-300 mb-8 leading-relaxed">
              Guru, Scholar, Athlete, Innovator, Philanthropist — One man's extraordinary journey of service and cultural preservation
            </p>
          </div>
        </div>
      </section>

      {/* Placeholder Sections for Future Development */}
      
      {/* Section 1: Early Life */}
      <section className="py-16 md:py-24 bg-slate-900">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">The Early Years & Foundation</h2>
          <div className="bg-slate-800 border-l-4 border-amber-400 p-8 rounded">
            <p className="text-slate-400 italic mb-6">Coming soon: Detailed story of Raghuram's childhood, family background, early influences, and the experiences that shaped his visionary outlook.</p>
            <p className="text-slate-300 leading-relaxed">
              This comprehensive section will explore how his upbringing instilled values of service, discipline, and cultural awareness that would define his entire life mission.
            </p>
          </div>
        </div>
      </section>

      {/* Section 2: Athletic Achievements */}
      <section className="py-16 md:py-24 bg-slate-800">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">Athletic Excellence & Physical Mastery</h2>
          <div className="bg-slate-900 border-l-4 border-amber-400 p-8 rounded">
            <p className="text-slate-400 italic mb-6">Coming soon: Renowned athletic accomplishments and how physical discipline shaped his character.</p>
            <p className="text-slate-300 leading-relaxed">
              Details about his remarkable athletic achievements, the energy he brings to performances, and how his body became an instrument of artistic expression.
            </p>
          </div>
        </div>
      </section>

      {/* Section 3: Spiritual & Scholarly Journey */}
      <section className="py-16 md:py-24 bg-slate-900">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">Spiritual & Scholarly Depth</h2>
          <div className="bg-slate-800 border-l-4 border-amber-400 p-8 rounded">
            <p className="text-slate-400 italic mb-6">Coming soon: His expertise in Vedas, Upanishads, tantric philosophy, yoga, meditation, and spiritual practices.</p>
            <p className="text-slate-300 leading-relaxed">
              In-depth exploration of his advanced knowledge of ancient spiritual sciences that inform his teaching and performances.
            </p>
          </div>
        </div>
      </section>

      {/* Section 4: Classical Arts Mastery */}
      <section className="py-16 md:py-24 bg-slate-800">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">Master of Performing Arts</h2>
          <div className="bg-slate-900 border-l-4 border-amber-400 p-8 rounded">
            <p className="text-slate-400 italic mb-6">Coming soon: Mastery of 12+ classical and folk dance forms, including Yakshagana and Bootakola.</p>
            <p className="text-slate-300 leading-relaxed">
              Detailed accounts of his training, rigorous practice, performances as an accomplished actor in films, TV, theater, and his work as director and choreographer of vibrant dance-drama productions.
            </p>
          </div>
        </div>
      </section>

      {/* Section 5: Performing Arts in Modern Media */}
      <section className="py-16 md:py-24 bg-slate-900">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">Performing Arts & Modern Media Innovation</h2>
          <div className="bg-slate-800 border-l-4 border-amber-400 p-8 rounded">
            <p className="text-slate-400 italic mb-6">Coming soon: His work in film, television, theater, and digital media.</p>
            <p className="text-slate-300 leading-relaxed">
              Stories from his roles in movies, TV series, commercials, PSAs, and both Indian and Western theatrical dramas. How he leverages social media and digital platforms to reach global audiences with ancient arts.
            </p>
          </div>
        </div>
      </section>

      {/* Section 6: Tech Innovation */}
      <section className="py-16 md:py-24 bg-slate-800">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">Tech Innovation & Invention</h2>
          <div className="bg-slate-900 border-l-4 border-amber-400 p-8 rounded">
            <p className="text-slate-400 italic mb-6">Coming soon: His work in hardware and software innovation since engineering college.</p>
            <p className="text-slate-300 leading-relaxed">
              How technology intersects with tradition in his vision, and his approach to digitizing and preserving ancient arts for future generations.
            </p>
          </div>
        </div>
      </section>

      {/* Section 7: Philanthropy & Charity */}
      <section className="py-16 md:py-24 bg-slate-900">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">Philanthropy & Community Service</h2>
          <div className="bg-slate-800 border-l-4 border-amber-400 p-8 rounded">
            <p className="text-slate-400 italic mb-6">Coming soon: Decades of charity work and community support.</p>
            <p className="text-slate-300 leading-relaxed">
              Detailed accounts of his service without seeking recognition, his impact on communities, and the philosophy of giving that drives his mission.
            </p>
          </div>
        </div>
      </section>

      {/* Section 8: Student Testimonials */}
      <section className="py-16 md:py-24 bg-slate-800">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">Voices of Transformation</h2>
          <p className="text-slate-400 italic mb-8">Testimonials and personal stories from students and mentees (coming soon)</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[1, 2, 3, 4, 5, 6].map(idx => (
              <div key={idx} className="bg-slate-900 p-6 rounded border border-slate-700 hover:border-amber-400 transition-colors">
                <p className="text-amber-400 font-semibold mb-2">Student Testimonial #{idx}</p>
                <p className="text-slate-400 italic text-sm">Coming soon...</p>
                <div className="mt-4 h-24 bg-slate-800 rounded animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 9: Wife & Family Legacy */}
      <section className="py-16 md:py-24 bg-slate-900">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">Wife & Family: The Foundation of Everything</h2>
          <div className="bg-slate-800 border-l-4 border-amber-400 p-8 rounded">
            <p className="text-slate-400 italic mb-6">Coming soon: The complete family story including his wife and three sons.</p>
            <p className="text-slate-300 leading-relaxed mb-6">
              Detailed narrative about his wife as co-founder and the crucial role she played in building YakshalokaUS. Stories of the three sons as tradition carriers and their individual journeys within the mission.
            </p>
            <p className="text-slate-300 leading-relaxed">
              How family sacrifice, support, and shared vision became the cornerstone of everything Raghuram has accomplished.
            </p>
          </div>
        </div>
      </section>

      {/* Section 10: Shivaratri & Sacred Performances */}
      <section className="py-16 md:py-24 bg-slate-800">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-amber-400 mb-6">Shivaratri: Sacred Transformation Through Art</h2>
          <div className="bg-slate-900 rounded-lg p-8 border border-slate-700">
            <p className="text-slate-300 leading-relaxed mb-6">
              Raghuram's Shivaratri performances across Southern California temples showcase his most innovative approach to cultural and spiritual preservation. These aren't merely performances—they are transformative spiritual experiences where Yakshagana becomes a vehicle for divine connection.
            </p>
            
            <Link
              to="/shivaratri"
              className="inline-block bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold py-2 px-6 rounded transition-colors"
            >
              Explore Shivaratri Performances
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Back to Our Story */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-slate-900 to-slate-950">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Learn the Complete Story</h2>
          <p className="text-slate-300 mb-8 max-w-2xl mx-auto">
            Want to understand Raghuram's vision, the family's journey, and the global impact? Start with our comprehensive story.
          </p>
          <Link 
            to="/our-story" 
            className="inline-block bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold py-3 px-8 rounded-lg transition-colors"
          >
            Back to Our Story
          </Link>
        </div>
      </section>

      {/* Note Section */}
      <section className="py-8 bg-slate-950 border-t border-slate-800">
        <div className="container mx-auto px-4 text-center text-slate-500 text-sm">
          <p>
            📝 <span className="text-slate-400">This page is under development. Content will be added as materials become available and are digitized from archives.</span>
          </p>
        </div>
      </section>
    </div>
  );
}
